import React from 'react';

export default function Split(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            width={124.417}
            height={195.739}
            style={{
            shapeRendering: "geometricPrecision",
            textRendering: "geometricPrecision",
            imageRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            }}
            viewBox="0 0 1127 1773"
            className={props.className}
        >
            <defs>
                <style>
                    {`
                        #c-${props.id} .fil1 {fill:#${props.base}}
                        #c-${props.id} .fil0 {fill:#${props.splitColor}}
                        #c-${props.id} .fil2 {fill:#252422;fill-rule:nonzero}
                    `}
                </style>
            </defs>
            <g id={`c-${props.id}`}>
                <path className="fil0" d="M287 1709c8,1 16,1 25,2 -8,-1 -17,-1 -25,-2zm82 5c9,0 18,1 27,1 -9,0 -18,-1 -27,-1zm29 1c6,0 12,1 18,1 -6,0 -12,-1 -18,-1zm38 2c10,0 19,1 29,1 -10,0 -19,-1 -29,-1zm119 2l7 0c279,0 454,-22 513,-31l0 -1123c-23,-28 -92,-123 -100,-255 -6,-107 7,-171 15,-203 -39,-13 -108,-36 -177,-48 -25,153 -130,263 -257,264l0 1396zm199 -1638c-40,22 -105,46 -199,44l0 144c93,-1 170,-78 199,-188z"/>
                <path className="fil1" d="M57 1687c69,8 283,32 497,32l0 -1396 -2 0c-129,0 -230,-105 -256,-261 -40,9 -76,22 -104,32 -13,5 -25,9 -34,12 -18,6 -29,9 -52,18 19,87 30,147 25,217 -8,118 -60,200 -77,225l4 1121zm497 -1561l0 144 -2 0c-95,0 -170,-75 -198,-190 39,20 103,43 191,46 3,0 6,0 9,0z"/>
                <path className="fil2" d="M57 1687c70,8 288,32 504,32 279,0 454,-22 513,-31l0 -1123c-23,-28 -92,-123 -100,-255 -6,-107 7,-171 15,-203 -39,-13 -108,-36 -177,-48 -25,154 -130,264 -259,264 -129,0 -230,-105 -256,-261 -40,9 -76,22 -104,32 -13,5 -25,9 -34,12 -18,6 -29,9 -52,18 19,87 30,147 25,217 -8,118 -60,200 -77,225l4 1121zm695 -1605c-41,23 -109,48 -207,44 -89,-3 -152,-26 -191,-46 28,115 104,190 198,190 94,0 172,-77 200,-188zm-463 -73l0 -2 14 -1c5,-1 10,-2 15,-3l12 -2 3 3 8 0c0,3 0,5 0,8 13,10 81,57 204,61 149,5 213,-61 216,-63l1 -1c0,-1 0,-3 0,-4l4 0 4 -5 14 2c96,13 198,48 237,62l2 1c25,9 20,35 15,53 -6,29 -20,89 -14,189 8,134 92,229 93,230l7 8 0 10 0 1178 -22 4c-8,1 -192,36 -544,36 -264,0 -531,-35 -534,-36l-23 -3 -5 -1186 6 -7c1,-1 63,-82 72,-204 5,-68 -7,-126 -28,-223l-5 -21 20 -9c42,-18 55,-22 78,-29 9,-3 20,-7 32,-11 31,-11 70,-25 116,-35z"/>
            </g>
        </svg>
    );
}
